document.addEventListener("DOMContentLoaded", function () {
    const editoriasImages = document.querySelectorAll(".editorias-images img");

    const triggers = [
        "editoria-desigualdades",
        "editoria-leis",
        "editoria-transicao",
        "editoria-desmatamento",
        "editoria-adaptacao",
        "editoria-mudancas"
    ];

    const positions = [
        [ // Posição 1 - Desigualdades
            { top: "20px", left: "15vw", zIndex: "9999"},
            { top: "40px", left: "13vw", zIndex: "1" },
            { top: "60px", left: "13vw", zIndex: "1" },
            { top: "55px", left: "15vw", zIndex: "1" },
            { top: "45px", left: "15vw", zIndex: "1" },
            { top: "30px", left: "13vw", zIndex: "1" },
        ],
        [ // Posição 2 - Política
            { top: "30px", left: "13vw", zIndex: "1" },
            { top: "25px", left: "15vw", zIndex: "9999" },
            { top: "40px", left: "15vw", zIndex: "1" },
            { top: "60px", left: "13vw", zIndex: "1" },
            { top: "55px", left: "13vw", zIndex: "1" },
            { top: "45px", left: "15vw", zIndex: "1" },
        ],
        [ // Posição 3 - Transição Energética
			{ top: "60px", left: "15vw", zIndex: "1" },
            { top: "55px", left: "13vw", zIndex: "1" },
            { top: "45px", left: "13vw", zIndex: "9999" },
            { top: "30px", left: "15vw", zIndex: "1" },
            { top: "20px", left: "15vw", zIndex: "1" },
            { top: "40px", left: "13vw", zIndex: "1" },
        ],
        [ // Posição 4 - Desmatamento
            { top: "45px", left: "13vw", zIndex: "1" },
            { top: "30px", left: "15vw", zIndex: "1" },
            { top: "20px", left: "15vw", zIndex: "1" },
            { top: "40px", left: "13vw", zIndex: "9999" },
			{ top: "60px", left: "13vw", zIndex: "1" },
            { top: "55px", left: "15vw", zIndex: "1" },
        ],
		[ // Posição 5 - Adaptação
            { top: "45px", left: "15vw", zIndex: "1" },
            { top: "30px", left: "13vw", zIndex: "1" },
            { top: "20px", left: "13vw", zIndex: "1" },
			{ top: "40px", left: "15vw", zIndex: "1"},
            { top: "55px", left: "15vw", zIndex: "9999" },
            { top: "50px", left: "13vw", zIndex: "1" },
        ],
		[ // Posição 6 - Novo normal
            { top: "55px", left: "13vw", zIndex: "1" },
            { top: "45px", left: "15vw", zIndex: "1" },
            { top: "30px", left: "15vw", zIndex: "1" },
            { top: "20px", left: "13vw", zIndex: "1" },
            { top: "40px", left: "13vw", zIndex: "1" },
            { top: "60px", left: "15vw", zIndex: "9999" },

        ],
    ];

    function updatePositions(index) {
        editoriasImages.forEach((img, imgIndex) => {
            const pos = positions[index][imgIndex];
            img.style.top = pos.top;
            img.style.left = pos.left;
            img.style.zIndex = pos.zIndex;
			jQuery(img).fadeIn(700);
        });

    }

    // Aplicar posição inicial
    updatePositions(0);

    // Adicionar eventos de hover para os elementos
    triggers.forEach((className, index) => {
        const element = document.querySelector(`.${className}`);
        if (element) {
            element.addEventListener("mouseenter", function () {
				editoriasImages.forEach((img, i) => {
					if (index === i){
						jQuery(img).fadeOut(0);

					}
				})
				updatePositions(index);

            });
        }
    });
});
